import Axios from "axios";
import {
    SET_COMPANY_MODULE_LIST,
    UNSET_COMPANY_MODULE_LIST,
    SET_TEMP_COMPANY_MODULE_LIST,
    UNSET_TEMP_COMPANY_MODULE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateCompanyModule, getCompanyModuleList } from "@/store/api";
// initial state
const state = {
  getCompanyModuleList: [],
  getTempCompanyModuleList: []
};

const getters = {
  getCompanyModuleList(state) {
    return state.getCompanyModuleList;
  },
  getTempCompanyModuleList(state) {
    return state.getTempCompanyModuleList;
  }
};
const mutations = {
  [SET_COMPANY_MODULE_LIST](state, data) {
    state.getCompanyModuleList = data;
  },
  [UNSET_COMPANY_MODULE_LIST](state) {
    state.getCompanyModuleList = [];
  },
  [SET_TEMP_COMPANY_MODULE_LIST](state, data) {
    state.getTempCompanyModuleList = data;
  },
  [UNSET_TEMP_COMPANY_MODULE_LIST](state) {
    state.getTempCompanyModuleList = [];
  }
};

const actions = {

  saveUpdateCompanyModule({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCompanyModule, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCompanyModuleList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCompanyModuleList, data)
        .then(function (response) {
          commit('SET_COMPANY_MODULE_LIST',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_COMPANY_MODULE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
